module.exports = __webpack_public_path__ + "01ea978f/img/scraper-icon.df6ccde5.svg";